import IClient from '~/interfaces/IClient';

export function getAddressClientPOS(client: IClient): string {
  if (client.street) {
    return `${client.street}, Nº ${client.number || 'S/N'}${
      client.neighborhood ? `, ${client.neighborhood}` : ''
    }${client.complement ? ` - ${client.complement}` : ''}`;
  }

  return client.address;
}
